export default __webpack_public_path__ + "static/media/alert.020010f2.svg";